import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from "./types";
import { continueAction, continueEditAction, showShowEditLimit, faqDetails, fetchMyPortfolio, logout, needHelp, navigateToProfile, onPageLoad, navigateToIc } from './action';
import SharedPropsService from '../../SharedPropsService';
import { getApplicationId, getContactUsDetails, getDateMonthYearFromEpochFromMicroseconds, showInterestCalculatorFlag } from "../../configs/utils";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
export const template = (height, totalAmount, userName, firstName, showLogout, date, isEnabled, contactUsDetails, onLoadComplete, showInterestCalculator) => {
    return {
        layout: {
            id: ROUTE.BORROWER_LANDING_SCREEN,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [{
                    id: 'borrowerLandingPage',
                    type: WIDGET.BORROWER_LANDING_PAGE,
                }],
        },
        datastore: {
            borrowerLandingPage: {
                fetchMF: {
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    type: ACTION.FETCH_MY_PORTFOLIO,
                    payload: {},
                },
                height,
                amount: totalAmount,
                logoutAction: {
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    type: ACTION.LOGOUT,
                    payload: {}
                },
                navigatetoFaq: {
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    type: ACTION.FAQ,
                    payload: {}
                },
                userName,
                needHelpAction: {
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    type: ACTION.NEED_HELP,
                    payload: {}
                },
                navigateToProfileAction: {
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    type: ACTION.NAVIGATE_PROFILE,
                    payload: {}
                },
                showLogout,
                firstName,
                continueAction: {
                    type: ACTION.CONTINUE_APPLICATION,
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    payload: {}
                },
                shouldShowEditLimit: {
                    type: ACTION.SHOW_EDIT_LIMIT,
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    payload: {}
                },
                continueEditLimitAction: {
                    type: ACTION.CONTINUE_EDIT_LIMIT,
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    payload: {}
                },
                latestDateOfEdit: date,
                loading: false,
                contactUsDetails,
                onLoadComplete: onLoadComplete,
                navToIC: {
                    type: ACTION.NAV_TO_IC,
                    routeId: ROUTE.BORROWER_LANDING_SCREEN,
                    payload: {}
                },
                showInterestCalculator: showInterestCalculator,
                showEditLimit: isEnabled
            }
        },
    };
};
export const borrowerLandingScreen = {
    onLoad: async ({ getHeight, network }, { reFetch }) => {
        const contactUsDetails = await getContactUsDetails();
        const applicationid = await getApplicationId();
        const user = await SharedPropsService.getUser();
        const accountId = user.linkedApplications[0].accountId;
        const userName = user?.user?.fullName;
        const splitUserName = userName?.split(' ');
        const firstName = splitUserName ? splitUserName[0] : "";
        const showLogout = await SharedPropsService.getShowLogout();
        const pledgeLimitResponse = await network.get(`${api.pledgeData}${applicationid}`, { headers: await getAppHeader() });
        await SharedPropsService.setPledgeData(pledgeLimitResponse);
        const shouldShowEditLimitResponse = await network.get(`${api.showEnableLimitV2}${applicationid}`, {
            headers: await getAppHeader()
        });
        const shouldShowEditLimit = shouldShowEditLimitResponse?.data?.isEnabled;
        await SharedPropsService.setShowEnableLimit(shouldShowEditLimitResponse?.data?.isEnabled);
        const isprevRouteFAQ = await AsyncStorage.getItem("prevRoute");
        let onLoadComplete = true;
        if (reFetch)
            onLoadComplete = false;
        reFetch = false;
        if (isprevRouteFAQ === ROUTE.FAQ) {
            onLoadComplete = true;
            await AsyncStorage.setItem("prevRoute", ROUTE.BORROWER_LANDING_SCREEN);
        }
        const stepResponseObject = pledgeLimitResponse?.data?.stepResponseObject;
        const repositoryAssetMetadataMap = pledgeLimitResponse?.data?.stepResponseObject?.repositoryAssetMetadataMap;
        const creditLimit = (stepResponseObject?.approvedCreditLimit || 0) + (stepResponseObject?.requestCreditLimit || 0);
        const camsDate = repositoryAssetMetadataMap?.CAMS.casFetchDate;
        const karvyDate = repositoryAssetMetadataMap?.KARVY.casFetchDate;
        const latestDate = Math.max(camsDate, karvyDate);
        const date = `${getDateMonthYearFromEpochFromMicroseconds(latestDate)}`;
        let totalAmount = 0;
        if (stepResponseObject) {
            if (creditLimit != null && creditLimit > 0)
                totalAmount = creditLimit;
            else
                totalAmount = 0;
        }
        let showInterestCalculator;
        let show_interest_calculator_feature = await showInterestCalculatorFlag();
        // @ts-ignore
        showInterestCalculator = !(show_interest_calculator_feature === false || show_interest_calculator_feature === 'false');
        return Promise.resolve(template(getHeight(), totalAmount, userName, firstName, showLogout, date, shouldShowEditLimit, contactUsDetails, onLoadComplete, showInterestCalculator));
    },
    action: {
        routeId: ROUTE.BORROWER_LANDING_SCREEN,
        type: ACTION.ON_LOAD,
        payload: {}
    },
    actions: {
        [ACTION.FETCH_MY_PORTFOLIO]: fetchMyPortfolio,
        [ACTION.LOGOUT]: logout,
        [ACTION.FAQ]: faqDetails,
        [ACTION.SHOW_EDIT_LIMIT]: showShowEditLimit,
        [ACTION.CONTINUE_APPLICATION]: continueAction,
        [ACTION.CONTINUE_EDIT_LIMIT]: continueEditAction,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.NAVIGATE_PROFILE]: navigateToProfile,
        [ACTION.ON_LOAD]: onPageLoad,
        [ACTION.NAV_TO_IC]: navigateToIc
    },
};
